import firebase from "firebase/app";
import "firebase/messaging";
import { coreHTTPClient } from "../services/webclient";
import { Capacitor } from "@capacitor/core";

/**
 * WARNING
 * WARNING
 * WARNING
 *
 * If you're fiddling around here, be sure to check the firebase
 * worker that runs on background called `firebase-messaging-sw.js`
 */

let firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID,
};

let token = "";
let messaging;

if (Capacitor.getPlatform() === "web") {
  try {
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    messaging = firebase.messaging();
    messaging.usePublicVapidKey(
      process.env.REACT_APP_FIREBASE_USEPUBLICVAPIDKEY
    );

    messaging
      .getToken()
      .then((currentToken) => {
        if (currentToken) {
          token = currentToken;
        } else {
          // Show permission request.
        }
      })
      .catch((err) => {});

    messaging.onMessage((payload) => {
      let { title, body, image, url } = payload.data;

      let notif = new Notification(title, {
        body,
        image,
        icon: image,
      });

      notif.onclick = () => (window.location.href = url);
    });
  } catch (err) {
    console.error("FCMService", err);
  }
}

export async function deleteToken() {
  try {
    messaging.deleteToken(token);
  } catch (err) {
    console.log("Fail to delete token");
  }
}

export async function getWebFCMToken() {
  return await messaging?.getToken();
}

export async function getMyTopics(token: string): Promise<string[]> {
  //As vezes o token vem vazio na primeira chamada
  try {
    if (!token) {
      return [];
    }

    return [];
  } catch {
  } finally {
    return [];
  }
}

type FirebaseTopicResponse = {
  success_count?: number;
  failure_count?: number;
  errors?: unknown;
};

function assertFirebaseTopicSuccess(
  response: FirebaseTopicResponse,
  action: "subscribe" | "unsubscribe",
  topic: string
) {
  if ((response.failure_count ?? 0) > 0 || (response.success_count ?? 0) < 1) {
    throw new Error(
      `Failed to ${action} topic ${topic}: success_count=${
        response.success_count ?? 0
      }, failure_count=${response.failure_count ?? 0}`
    );
  }
}

export async function subscribeTokenToTopic(topic) {
  try {
    const response = await coreHTTPClient.post<FirebaseTopicResponse>(
      "/v3/notifications/firebase/",
      {
        token,
        topic,
      }
    );

    assertFirebaseTopicSuccess(response.data, "subscribe", topic);
  } catch (err) {
    console.error("FCMService subscribeTokenToTopic", err);
  }
}

export async function unsubscribeTokenFromTopic(topic) {
  try {
    const response = await coreHTTPClient.delete<FirebaseTopicResponse>(
      "/v3/notifications/firebase/",
      {
        data: { token, topic },
      }
    );

    assertFirebaseTopicSuccess(response.data, "unsubscribe", topic);
  } catch (err) {
    console.error("FCMService unsubscribeTokenFromTopic", err);
  }
}
